// /src/store/tasksManagment/reducer.ts

import {
  TasksState,
  initialState,
  TasksActionTypes,
  TranscodingTaskStatus,
  UPSERT_TRANSCODING_TASK,
  REMOVE_TRANSCODING_TASK,
} from './types';

const tasksReducer = (state: TasksState = initialState, action: TasksActionTypes): TasksState => {
  switch (action.type) {
    case UPSERT_TRANSCODING_TASK: {
      const { mediaId, label, progress, status } = action.payload;
      // startTime figé à la première apparition de la tâche : sinon chaque tick du
      // sondage (une seconde) la rajeunirait, et un tri par ancienneté ne voudrait
      // plus rien dire.
      const existing = state.transcodingTasks[mediaId];
      return {
        ...state,
        transcodingTasks: {
          ...state.transcodingTasks,
          [mediaId]: {
            mediaId,
            label,
            progress,
            status,
            startTime: existing?.startTime ?? new Date(),
            // Même logique que startTime : figé au premier COMPLETED, sinon
            // chaque probe redonnerait une durée nulle.
            endTime: status === TranscodingTaskStatus.COMPLETED
              ? (existing?.endTime ?? new Date())
              : existing?.endTime,
          },
        },
      };
    }

    case REMOVE_TRANSCODING_TASK: {
      const { [action.payload.mediaId]: removed, ...rest } = state.transcodingTasks;
      return { ...state, transcodingTasks: rest };
    }

    default:
      return state;
  }
};

export default tasksReducer;
